/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Support_ReceivedInputs */

const en_status_support_received = /** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribution Received`)
};

const es_status_support_received = /** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribución Recibida`)
};

const fr_status_support_received = /** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribution reçue`)
};

const de_status_support_received = /** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag erhalten`)
};

const id_status_support_received = /** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontribusi Diterima`)
};

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const ja_status_support_received = en_status_support_received;

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const zh_status_support_received = en_status_support_received;

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const ar_status_support_received = en_status_support_received;

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const it_status_support_received = en_status_support_received;

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const ru_status_support_received = en_status_support_received;

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const pt_status_support_received = en_status_support_received;

/** @type {(inputs: Status_Support_ReceivedInputs) => LocalizedString} */
const ko_status_support_received = en_status_support_received;

/**
* | output |
* | --- |
* | "Contribution Received" |
*
* @param {Status_Support_ReceivedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const status_support_received = /** @type {((inputs?: Status_Support_ReceivedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Support_ReceivedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_support_received(inputs)
	if (locale === "es") return es_status_support_received(inputs)
	if (locale === "fr") return fr_status_support_received(inputs)
	if (locale === "de") return de_status_support_received(inputs)
	if (locale === "ja") return ja_status_support_received(inputs)
	if (locale === "zh") return zh_status_support_received(inputs)
	if (locale === "ar") return ar_status_support_received(inputs)
	if (locale === "id") return id_status_support_received(inputs)
	if (locale === "it") return it_status_support_received(inputs)
	if (locale === "ru") return ru_status_support_received(inputs)
	if (locale === "pt") return pt_status_support_received(inputs)
	return ko_status_support_received(inputs)
});